export default __webpack_public_path__ + "static/media/kainero-logo.9fa50610.png";